import { render, staticRenderFns } from "./ViewerGISModel.vue?vue&type=template&id=64df2989&scoped=true"
import script from "./ViewerGISModel.vue?vue&type=script&lang=js"
export * from "./ViewerGISModel.vue?vue&type=script&lang=js"
import style0 from "./ViewerGISModel.vue?vue&type=style&index=0&id=64df2989&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64df2989",
  null
  
)

export default component.exports